export const getServicePath = (slug) => `/services/${slug}`;
export const getPrivacyPolicyPath = () => '/privacy-policy';
export const getDisclaimerPath = () => '/disclaimer';

export const isHomePagePath = (pathname) => {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  return normalizedPath === '/';
};
